<template>
  <div>
    <div v-show="available" class="chart teste">
      <canvas id="company-chart"></canvas>
    </div>
  </div>
</template>
<script>
import Chart from "chart.js";
import DashboardExecutoraService from "../../../common/services/dashboards/dashboard_executora.service";
import helpers from "@/common/utils/helpers";
import categorias from "@/common/enum/GraficoExecutora";
export default {
  data: () => ({
    chartData: {
      type: "bar",
      data: {
        labels: ["RH", "ST", "MC", "MP", "VD", "OU"],
        datasets: [
          {
            label: "Previsto",
            backgroundColor: "#90caf9",
            borderWidth: 1,
          },
          {
            label: "Realizado",
            backgroundColor: "#f6e384",
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        legend: {
          position: "bottom",
        },
        lineTension: 1,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 25,
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            title: function (value) {
              let labelName = categorias[value[0].label];
              return labelName;
            },
            label: function (tooltipItem) {
              return helpers.formatarValor(tooltipItem.value);
            },
          },
        },
      },
    },
    dados: {
      despesasPrevistas: 0,
      despesasRealizadas: 0,
    },
    available: false,
    chart: null,
  }),

  methods: {
    buscarDados: function (projetoId) {
      DashboardExecutoraService.graficosDespesas(
        this.empresasSelecionada,
        projetoId
      ).then((response) => {
        this.dados = response.data.data;
      });
    },
    renderChart: function () {
      if (this.chart) {
        this.chart.destroy();
      }
      const ctx = document.getElementById("company-chart");
      this.chart = new Chart(ctx, this.chartData);
    },
  },
  watch: {
    dados(newValue) {
      this.chartData.data.datasets[0].data = [
        newValue.despesasPrevistas.recursosHumanos,
        newValue.despesasPrevistas.servicosTerceiros,
        newValue.despesasPrevistas.materiaisConsumo,
        newValue.despesasPrevistas.materiaisPermanentes,
        newValue.despesasPrevistas.viagensEDiarias,
        newValue.despesasPrevistas.outros,
      ];
      this.chartData.data.datasets[1].data = [
        newValue.despesasRealizadas.recursosHumanos,
        newValue.despesasRealizadas.servicosTerceiros,
        newValue.despesasRealizadas.materiaisConsumo,
        newValue.despesasRealizadas.materiaisPermanentes,
        newValue.despesasRealizadas.viagensEDiarias,
        newValue.despesasRealizadas.outros,
      ];
      this.available = true;
      this.renderChart();
    },
  },
  computed: {
    empresasSelecionada: function () {
      if (!this.$store.state.app.selectedCompanyObj) return null;
      return this.$store.state.app.selectedCompanyObj.id;
    },
  },
  mounted() {
    this.buscarDados();
  },
};
</script>
<style lang="">
</style>